import { render, staticRenderFns } from "./FileSection.vue?vue&type=template&id=565f6986&scoped=true"
import script from "./FileSection.vue?vue&type=script&lang=js"
export * from "./FileSection.vue?vue&type=script&lang=js"
import style0 from "./FileSection.vue?vue&type=style&index=0&id=565f6986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f6986",
  null
  
)

export default component.exports